/** splitmix32: expands one seed into well-mixed words. */
function splitmix32(seed) {
    let s = seed >>> 0;
    return () => {
        s = (s + 0x9e3779b9) >>> 0;
        let z = s;
        z = Math.imul(z ^ (z >>> 16), 0x85ebca6b) >>> 0;
        z = Math.imul(z ^ (z >>> 13), 0xc2b2ae35) >>> 0;
        return (z ^ (z >>> 16)) >>> 0;
    };
}
export function seedRng(seed) {
    const next = splitmix32(seed);
    const r = [next(), next(), next(), next()];
    if (r[0] === 0 && r[1] === 0 && r[2] === 0 && r[3] === 0)
        r[0] = 1; // all-zero state never moves
    return r;
}
const rotl = (x, k) => ((x << k) | (x >>> (32 - k))) >>> 0;
/** Next uint32. Mutates the state in place. */
export function nextU32(r) {
    const result = Math.imul(rotl(Math.imul(r[1], 5) >>> 0, 7), 9) >>> 0;
    const t = (r[1] << 9) >>> 0;
    r[2] = (r[2] ^ r[0]) >>> 0;
    r[3] = (r[3] ^ r[1]) >>> 0;
    r[1] = (r[1] ^ r[2]) >>> 0;
    r[0] = (r[0] ^ r[3]) >>> 0;
    r[2] = (r[2] ^ t) >>> 0;
    r[3] = rotl(r[3], 11);
    return result;
}
/** Unbiased integer in [0, n). */
export function nextInt(r, n) {
    if (!Number.isInteger(n) || n <= 0 || n > 0x1_0000_0000)
        throw new RangeError(`nextInt(${n})`);
    const limit = 0x1_0000_0000 - (0x1_0000_0000 % n);
    for (;;) {
        const x = nextU32(r);
        if (x < limit)
            return x % n;
    }
}
/** Fisher-Yates shuffle of a copy. */
export function shuffled(r, items) {
    const a = items.slice();
    for (let i = a.length - 1; i > 0; i--) {
        const j = nextInt(r, i + 1);
        const tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a;
}
//# sourceMappingURL=rng.js.map